/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Updated_ClientInputs */

const en_stage_updated_client = /** @type {(inputs: Stage_Updated_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client stage updated successfully`)
};

const pt_br2_stage_updated_client = /** @type {(inputs: Stage_Updated_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa do cliente atualizada com sucesso`)
};

/**
* | output |
* | --- |
* | "Client stage updated successfully" |
*
* @param {Stage_Updated_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_updated_client = /** @type {((inputs?: Stage_Updated_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Updated_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_updated_client(inputs)
	return pt_br2_stage_updated_client(inputs)
});